<template>
    <div>
        <p class="stack-m">Select using <em>{{action.pickInstruction.method | unKebabCase}}</em>.</p>
        <table class="table table-definition">
            <tbody>
            <tr v-for="item in sortedWeights">
                <td>
                    <div class="padding-bottom-xxs">{{item.label}}</div>
                    <item-weight-bar :relative-weight="getRelativeWeight(item)"/>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';
    import ItemWeightBar from '../shared/item-weight-bar';

    export default {
        name: 'pick-gateway-account-summary',
        extends: BaseActionSummary,
        components: {ItemWeightBar},
        computed: {
            sortedWeights() {
                return [...this.action.pickInstruction.weightedList]
                    // filter out items with no weight at all
                    .filter(({weight}) => weight > 0)
                    // sort weights descending
                    .sort((a, b) => b.weight - a.weight);
            },
        },
        methods: {
            getRelativeWeight({weight}) {
                return Math.round((weight / this.action.pickInstruction.totalWeight) * 100);
            },
        },
    };
</script>
